import { REDUCERS } from '@/constants/reducers';
import { Context } from '@/context';
import { useCallback, useContext } from 'react';

const useShowPlayerAlineacionProbable = (player) => {
    const { dispatch } = useContext(Context);

    const onClick = useCallback(() => {
        dispatch({ type: REDUCERS.SET_PLAYER_ALINEACION_PROBABLE, payload: player });
    }, [dispatch]);

    return onClick;
};

export default useShowPlayerAlineacionProbable;
